import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState, } from 'react';
import clsx from 'clsx';
import { Box, TextField, InputLabel, Typography, InputAdornment, ClickAwayListener, IconButton, } from '@mui/material';
import CalendarIcon from '@mui/icons-material/DateRange';
import { LocalizationProvider, DatePicker, } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { formatISO } from 'date-fns';
import useInputLabelDisplay from '../../../hooks/useInputLabelDisplay';
import WithErrorMessage from '../withErrorMessage/WithErrorMessage';
import datePickerStyles from './datePicker.styles'; // eslint-disable-line
const DatePickerWidget = props => {
    const [isOpen, setIsOpen] = useState(false);
    const { id, value, onChange, rawErrors, label, required, classes, pickerProps, } = props;
    const { getLabel } = useInputLabelDisplay();
    const displayedLabel = getLabel(label);
    const styles = datePickerStyles();
    const handleChange = useCallback((newValue, keyboardValue) => {
        if (newValue && !keyboardValue) {
            onChange(formatISO(newValue).replace(/T(.*)/g, ''));
        }
    }, [onChange]);
    const handleOpen = useCallback(event => {
        event.stopPropagation();
        setIsOpen(open => !open);
    }, []);
    const handleClose = useCallback(() => {
        setIsOpen(false);
    }, []);
    const togglePicker = useCallback(event => {
        event.preventDefault();
        event.stopPropagation();
        setIsOpen(prev => !prev);
    }, []);
    const hasErrors = rawErrors?.length > 0;
    return (_jsx(LocalizationProvider, { dateAdapter: AdapterDateFns, children: _jsx(ClickAwayListener, { onClickAway: handleClose, children: _jsx(Box, { className: clsx(styles.container, classes?.container), children: _jsxs(WithErrorMessage, { error: hasErrors ? rawErrors[0] : undefined, className: clsx(styles.helper, classes?.helper), "data-test": `${id}:datepicker:error`, children: [_jsx(Typography, { variant: "subtitle1", children: _jsx(InputLabel, { htmlFor: id, required: required, className: clsx(styles.inputLabel, classes?.inputLabel), children: displayedLabel }, void 0) }, void 0), _jsx(DatePicker, { ...pickerProps, open: isOpen, value: value ? new Date(value) : null, onChange: handleChange, onClose: handleClose, onAccept: handleChange, inputFormat: "dd/MM/yyyy", InputProps: {
                                classes: {
                                    root: clsx(styles.root, classes?.root),
                                    input: clsx(styles.input, classes?.input),
                                    notchedOutline: clsx(styles.noBorderRadius, classes?.noBorderRadius),
                                },
                            }, OpenPickerButtonProps: {
                                classes: {
                                    root: clsx(styles.iconButton, classes?.iconButton),
                                },
                            }, PopperProps: {
                                className: clsx({
                                    [styles.pickerRoot]: isOpen,
                                    ...(classes?.pickerRoot && {
                                        [classes.pickerRoot]: isOpen,
                                    }),
                                }),
                            }, renderInput: ({ classes, className, InputProps, inputRef, inputProps, ...rest }) => (_jsx(TextField, { ...rest, id: id, className: className, fullWidth: true, inputProps: {
                                    ...inputProps,
                                    readOnly: true,
                                }, inputRef: inputRef, error: hasErrors, required: required, onClick: togglePicker, value: value, classes: {
                                    root: clsx([
                                        styles.root,
                                        classes?.root,
                                        {
                                            [styles.error]: hasErrors,
                                        },
                                    ]),
                                }, InputProps: {
                                    ...InputProps,
                                    readOnly: true,
                                    endAdornment: (_jsx(InputAdornment, { position: "end", children: _jsx(IconButton, { className: styles.iconButton, onClick: handleOpen, disableTouchRipple: true, children: _jsx(CalendarIcon, {}, void 0) }, void 0) }, void 0)),
                                } }, void 0)) }, void 0)] }, void 0) }, void 0) }, void 0) }, void 0));
};
export default DatePickerWidget;
//# sourceMappingURL=DatePicker.js.map